<template>
  <div>
    <div v-if="storage.deliveryAddress" class="mb-6">
      <div class="d-flex align-center mb-4">
        <v-icon color="#3EA56E" class="mr-2">mdi-map-marker-outline</v-icon>
        <span class="detail-title">Delivery Address</span>
      </div>
      
      <v-card flat class="address-card pa-4 rounded-lg text-left">
        <div class="customer-name mb-1">
          {{ storage.deliveryAddress.firstname }} {{ storage.deliveryAddress.lastname }}
        </div>
        <div class="address-text mb-4">
          {{ storage.deliveryAddress.streetAddress }},<br>
          {{ storage.deliveryAddress.locality }}, {{ storage.deliveryAddress.city }},<br>
          {{ storage.deliveryAddress.district }}, {{ storage.deliveryAddress.state }} - {{ storage.deliveryAddress.pincode }}
        </div>
        
        <div class="contact-info">
          <div v-if="storage.deliveryAddress.delphone" class="contact-item mb-1">
            <v-icon size="16" color="#64748b" class="mr-2">mdi-phone-outline</v-icon>
            <span>{{ storage.deliveryAddress.delphone }}</span>
          </div>
          <div v-if="storage.deliveryAddress.email" class="contact-item" style="align-items: flex-start;">
            <v-icon size="16" color="#64748b" class="mr-2" style="margin-top: 2px;">mdi-email-outline</v-icon>
            <span style="word-break: break-all;">{{ storage.deliveryAddress.email }}</span>
          </div>
        </div>
      </v-card>
    </div>

    <div>
      <div class="d-flex align-center mb-4">
        <v-icon color="#3EA56E" class="mr-2">mdi-receipt-outline</v-icon>
        <span class="detail-title">Price Breakdown</span>
      </div>

      <v-card flat class="price-card pa-4 rounded-lg">
        <div class="price-row mb-3">
          <span class="label">Total Price ({{ items ? items.length : 0 }} items)</span>
          <span class="value">Rs. {{ storage.actualOrderTotal || 0 }}</span>
        </div>
        
        <div class="price-row mb-3">
          <span class="label">Discount</span>
          <span class="value discount">- Rs. {{ Number(storage.priceDifference || 0).toFixed(2) }}</span>
        </div>
        
        <div class="price-row mb-3">
          <span class="label">Taxable Amount</span>
          <span class="value">Rs. {{ Number(storage.taxableAmount || 0).toFixed(2) }}</span>
        </div>
        
        <div class="price-row mb-2">
          <span class="label">GST</span>
          <span class="value">Rs. {{ Number(storage.taxAmount || 0).toFixed(2) }}</span>
        </div>
        
        <div class="price-row mb-1 ml-6">
          <span class="label" style="font-size: 13px; opacity: 0.8;">SGST</span>
          <span class="value" style="font-size: 13px; opacity: 0.8;">Rs. {{ Number((storage.taxAmount || 0) / 2).toFixed(2) }}</span>
        </div>
        
        <div class="price-row mb-3 ml-6">
          <span class="label" style="font-size: 13px; opacity: 0.8;">CGST</span>
          <span class="value" style="font-size: 13px; opacity: 0.8;">Rs. {{ Number((storage.taxAmount || 0) / 2).toFixed(2) }}</span>
        </div>
        
        <div class="price-row mb-3">
          <span class="label">Packing Charge</span>
          <span class="value">Rs. {{ storage.packingCharge || 0 }}</span>
        </div>
        
        <div class="price-row mb-3">
          <span class="label">Delivery Charge</span>
          <span class="value">Rs. {{ storage.deliveryCharge || 0 }}</span>
        </div>
        
        <v-divider class="my-3"></v-divider>
        
        <div class="price-row total-row">
          <span class="total-label">Order Total</span>
          <span class="total-value">Rs. {{ storage.orderTotal || 0 }}</span>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
export default {
  props: ["storage", "items"],
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      deliverydate: new Date(),
      user: {
        deliveryAddress: [],
      },
      cart: {},
    };
  },
  methods: {},
};
</script>

<style scoped>
.detail-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 15px;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.address-card, .price-card {
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
}

.customer-name {
  font-family: "poppinssemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
}

.address-text {
  font-family: "poppinsregular", sans-serif;
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

.contact-item {
  display: flex;
  align-items: center;
  font-family: "poppinsmedium", sans-serif;
  font-size: 13px;
  color: #475569;
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  font-family: "poppinsregular", sans-serif;
  font-size: 14px;
  color: #64748b;
}

.value {
  font-family: "poppinsmedium", sans-serif;
  font-size: 14px;
  color: #1e293b;
}

.discount {
  color: #10b981;
}

.total-label {
  font-family: "poppinssemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
}

.total-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 18px;
  color: #3ea56e;
}
</style>